import { useEffect } from 'react'
import clsx from 'clsx'
import { AsideMenuMain } from './AsideMenuMain'
import { useSelector } from 'react-redux'
import { IModuleModel } from 'src/app/modules/siteSettings/components/moduleManager/Model'
import { isEmpty } from 'lodash'
import { DrawerComponent, ScrollComponent, ToggleComponent } from '../../../assets/ts/components'
import { useLocation } from 'react-router'

type Props = {
  asideMenuCSSClasses: string[]
}

const AsideMenu: React.FC<Props> = ({ asideMenuCSSClasses }) => {
  const module: any = useSelector((state: any) => state.auth.module)

  const { pathname } = useLocation()

  useEffect(() => {
    setTimeout(() => {
      DrawerComponent.reinitialization()
      ToggleComponent.reinitialization()
      ScrollComponent.reinitialization()
    }, 0)
  }, [pathname])

  const subRoutesToExclude = [
    '/update-faqs/:id',
    '/new-cif/new-cif-review/:id',
    '/new-cif/new-cif-review/checker/:id',
    '/kyc/kyc-update-list/:id',
    '/cpu-maker/new-cif-and-account-list/:id',
    '/cpu-maker/new-cif-and-account-list/corporate-bank/:id',
    '/cpu-checker/new-cif-and-account-list/:id',
    '/create-new-cif-and-account/biometric-verification',
    '/branch-checker/new-cif-and-account-list/:id',
    '/branch-checker/new-cif-and-corporate-account-list/:id',
    '/create-new-cif-and-account/update-and-review/:id',
    '/create-new-cif-and-account/biometric-verification/:id',
    '/linked-entities/linked-entities-review/:id',
    '/branch-maker/linked-entities/review-linked-entities/:id',
    '/cpu-checker/new-cif-and-account-list/corporate/:id',
    '/existing-cif/existing-cif-listing/:id',
    '/existing-cif/existing-cif-review/:id',
    '/kyc/kyc-update-list/checker/:id',
    '/kyc/kyc-update-list/branch-maker/:id',
    `/ancillary-service/branch-checker-review/:id`,
  ]

  const routeData = !isEmpty(module?.moduleData)
    ? module?.moduleData.map((parentData: any) => ({
      route: parentData.alias,
      title: parentData.name,
      subRoutes: parentData?.children
        ?.filter((item: any) => {
          return !subRoutesToExclude.includes(item?.alias)
        })
        .map((childrenData: IModuleModel) => ({
          route: childrenData.alias,
          title: childrenData.name,
        })),
    }))
    : []
  // No `hover-scroll-overlay-y` / `data-kt-scroll` on the wrapper below:
  // ScrollComponent would give it its own height + overflow-y, which inside the
  // antd drawer (whose body already scrolls) produced TWO scrollbars. The drawer
  // body is the single scroller now.
  return (
    <div id='kt_aside_menu_wrapper' className='gibl-aside-menu-wrapper'>
      <div
        id='#kt_aside_menu'
        data-kt-menu='true'
        className={clsx(
          'menu menu-column gibl-aside-menu',
          asideMenuCSSClasses.join(' ')
        )}
      >


        <AsideMenuMain data={routeData} />
      </div>
    </div>
  )
}

export { AsideMenu }
